import { Point } from '../../common/maths/geometry/pointTypes';
import { omit } from 'lodash/fp';

const RETURN_STATE_LOCAL_STORAGE_KEY = 'milanote.returnState';
const RETURN_STATE_LIMIT = 100;

interface ReturnState {
    scrollTop: number;
    scrollLeft: number;
    width: number;
    height: number;
    zoomScale: number;
    zoomTranslationPx: Point;
}

const getLast = <V>(obj: { [key in string]: V }, n = 1) => {
    const keys = Object.keys(obj);
    if (keys.length <= n) return obj;

    return keys.slice(keys.length - n, keys.length).reduce(
        (acc, key) => ({
            ...acc,
            [key]: obj[key],
        }),
        {},
    );
};

export const clearCanvasReturnState = (): void => {
    localStorage.removeItem(RETURN_STATE_LOCAL_STORAGE_KEY);
};

export const clearBoardsFromCanvasReturnState = (...boardIds: string[]): void => {
    const currentReturnStateString = localStorage.getItem(RETURN_STATE_LOCAL_STORAGE_KEY);
    const currentReturnState = currentReturnStateString ? JSON.parse(currentReturnStateString) : {};

    const newReturnState = omit(boardIds, currentReturnState);

    localStorage.setItem(RETURN_STATE_LOCAL_STORAGE_KEY, JSON.stringify(newReturnState));
};

export const getCanvasReturnState = (boardId: string): ReturnState => {
    const currentReturnStateString = localStorage.getItem(RETURN_STATE_LOCAL_STORAGE_KEY);
    const currentReturnState = currentReturnStateString ? JSON.parse(currentReturnStateString) : {};

    return currentReturnState[boardId];
};

export const saveCanvasReturnState = (boardId: string, returnState: ReturnState): void => {
    const currentReturnStateString = localStorage.getItem(RETURN_STATE_LOCAL_STORAGE_KEY);
    const currentReturnState = currentReturnStateString ? JSON.parse(currentReturnStateString) : {};

    delete currentReturnState[boardId];

    const newReturnState = getLast({ ...currentReturnState, [boardId]: returnState }, RETURN_STATE_LIMIT);

    localStorage.setItem(RETURN_STATE_LOCAL_STORAGE_KEY, JSON.stringify(newReturnState));
};
